module.exports = __webpack_public_path__ + "img/banks.3cd2c9de.svg";